import { minChars } from "core/CheckoutForm/helpers";

export const getFormattedTeams = ({ ownedTeams }) => {
    if (!ownedTeams) return;

    let allTeamOptions = [];

    ownedTeams.map(team => {
        // reassign "name" of team to "option" key:
        allTeamOptions.push({
            option: team.displayName,
            slug: team.id
        });
    });

    return allTeamOptions;
};

export const getOwnerId = ({ username, ownedTeams, userId }) => {
    if (!username) return userId;

    const matchedObject = ownedTeams.find(team => team.username === username);

    return matchedObject ? matchedObject.id : userId;
};

const isPrivacySelected = value => {
    return value === "Private" || value === "Public";
};

export const validatePrivacy = [
    {
        isValid: isPrivacySelected,
        errorMsg: "Please select private or public"
    }
];

const isOwnerSelected = value => {
    return value !== "Select Owner (required)";
};

export const validateOwnership = [
    {
        isValid: isOwnerSelected,
        errorMsg: "Please select the owner for the kit"
    }
];

export const validateNameOfKit = [
    {
        isValid: minChars(1),
        errorMsg: "A name is required to create a kit"
    }
];

export const getSavedToKit = ({ hasSubscription, allKits, kitIdsWithIcon }) => {
    let allKitIds = [];

    allKits.map(kit => {
        //if user does not have a subscription and only if the kit is named "favorites", grab kit id:
        if (!hasSubscription) {
            kit.name === "Favorites" && !kit.isLocked && allKitIds.push(kit.id);
        } else {
            !kit.isLocked && allKitIds.push(kit.id);
        }
    });

    return allKitIds.some(kitId => kitIdsWithIcon.includes(kitId));
};
